export default __webpack_public_path__ + "logininiciosesion.jpg";